import { NumberField, NumberFieldProps } from './number-field';
import { FieldValues, Path } from 'react-hook-form';

export interface EurorepairCalcFieldProps<T extends FieldValues = FieldValues>
  extends Omit<NumberFieldProps<T>, 'name'> {
  name?: Path<T>;
}

export const EurorepairCalcField = <T extends FieldValues = FieldValues>({
  name = 'euroRepairCalc' as Path<T>,
  ...rest
}: EurorepairCalcFieldProps<T>) => {
  return <NumberField name={name} {...rest} isSmallSize allowNegative={false} />;
};
